import React from "react";
import { Helmet } from "react-helmet";

const CorporateAnnouncement = () => {
  return (
    <div>
      <Helmet>
        <title>Corporate Announcement | Nandan Denim Ltd .</title>
      </Helmet>
    </div>
  )
};

export default CorporateAnnouncement;
